import { withFlexProps } from '@hocs';
import { Flex, theme, Typography } from '@styles';
import { node, shape, string } from 'prop-types';
import React from 'react';

const DescriptionCard = ({ containerProps, content, textVariant }) => (
  <Flex
    backgroundColor="rgba(255, 255, 255, 0.08)"
    borderRadius={8}
    p={24}
    {...containerProps}
  >
    <Typography
      color={theme.colors.white[100]}
      fontWeight={400}
      variant={textVariant}
    >
      {content}
    </Typography>
  </Flex>
);

DescriptionCard.propTypes = {
  containerProps: shape({}),
  content: node.isRequired,
  textVariant: string,
};

DescriptionCard.defaultProps = {
  containerProps: {},
  textVariant: 'MS-regular-s18-lh22',
};

export default withFlexProps(DescriptionCard);
